/**
 * Materials
 *
 * @returns {void}
 */
const materials = (first_call = true) => {

    if(first_call) {
        $('.wpcf7-form').append("<input type='hidden' name='model'/>");
        $('.wpcf7-form').append("<input type='hidden' name='material'/>");
    }

    const fields = {
        model: $('[type="hidden"][name="model"]'),
        material: $('[type="hidden"][name="material"]'),
    };

    const $image = $('.product-constructor__overview > img');
    const loader = $('.product-constructor__overview .js-ajax-loader');

    loader.removeClass('active');
    $image.removeAttr('srcset');
    $image.removeAttr('sizes');
    $image.removeAttr('width');
    $image.removeAttr('height');

    let $materials = $(document).find('.material__item');

    let material;

    fields.model.val($('.js-product-intro').text());

    $(document).on('click', '.material__item', function () {
        const el = $(this);
        if (!el.hasClass('is-current')) {

            loader.addClass('active');

            if($('.constructor-canvas').length > 0) {
                el.parents('.options-section').find('.material__item').removeClass('is-current');
            }
            else {
                $(document).find('.material__item').removeClass('is-current');
            }
            el.addClass('is-current');
            material = el.data('material');
            fields.material.val(material);

            if(typeof product !== "undefined") {
                product.variant = material;
            }

            if(el.data('is-img-default') == 1) {
                console.log('show img default');
                $('.no-image-alert').show();
            }
            else {
                $('.no-image-alert').hide();
            }

            if(!$(document).find('.js-materials').hasClass('blocked-from-configurations')) {

                $image.attr({
                    src: el.data('image-url'),
                    alt: el.data('image-alt'),
                });

                setTimeout(function() {
                    loader.removeClass('active');
                }, 400);
            }
        }
    });

    if($('.js-configuration, .js-configurator-module').length === 0) {
        $materials.eq(0).click()
    }

};

export default materials;
